import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Attachments_upload extends PureComponent {
  render() {
    return (
      <div className="row" id="attachments_upload">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Attachment Upload</h2>
              <p>
                Uploading attachments to records is a two-step process. The
                first step is to get an upload URL which returns a unique AWS S3
                signed URL. This signed URL will last for an hour and is
                restricted to a specific content type.{" "}
              </p>
              <p>
                Once you have your signed URL, you will need to upload your
                file. Below the signed URL example is an example of how to
                upload a file using JavaScript / node.js.
              </p>
              <p>Attachments are limited to 5GB.</p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Attachment Upload Example</h2>
              <h3>Get Upload URL</h3>
              <p>
                In this example we will get a secure upload URL connected to
                record 454 for the file "screenshot.png".
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/
                <span className="jsonY">454</span>/attachment/upload
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"screenshot.png"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"content_type"</span>:{" "}
                  <span className="jsonY">"image/jpeg"</span>
                </div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"url"</span>:{" "}
                  <span className="jsonY">
                    "https://nexoid-example.s3.region.amazonaws.com/example/86594/record/data_type/454/m618r9vh4zj01rqx/screenshot?AWSAccessKeyId=BKIAILPXCGKYNHX55O2P&amp;Content-Type=image%2Fpng&amp;Expires=1583606568&amp;Signature=fuoAdcRfr34FJ4jAuSckDIkWmc8%4D"
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"content_type"</span>:{" "}
                  <span className="jsonY">"image/png"</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
            <section>
              <h3>Send File to Upload URL</h3>
              <p>
                This example uses javascript to upload a file to an upload URL.
              </p>
              <p>JavaScript:</p>
              <div className="darkCode">
                <div>
                  <span className="jsDeclaration">var</span>{" "}
                  <span className="jsVarName">file</span>;
                </div>
                <div>
                  <span className="jsDeclaration">var</span>{" "}
                  <span className="jsVarName">contentType</span> ={" "}
                  <span className="jsString">"image/jpeg"</span>;
                </div>
                <div>
                  <span className="jsDeclaration">var</span>{" "}
                  <span className="jsVarName">uploadURL</span> ={" "}
                  <span className="jsString">
                    "https://nexoid-users-example.s3..."
                  </span>
                  ;
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsDeclaration">var</span>{" "}
                  <span className="jsVarName">xhr</span> ={" "}
                  <span className="jsDeclaration">new</span>{" "}
                  <span className="jsMethod1">XMLHttpRequest</span>();
                </div>
                <div>
                  <span className="jsDeclaration">var</span>{" "}
                  <span className="jsVarName">percentageComplete</span> ={" "}
                  <span className="jsNumber">-1</span>;
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsVarName">xhr</span>.
                  <span className="jsVarName">upload</span>.
                  <span className="jsMethod2">addEventListener</span>(
                  <span className="jsString">"progress"</span>,{" "}
                  <span className="jsDeclaration">function</span> (
                  <span className="jsVarName">e</span>) &#123;
                </div>
                <div className="i1">
                  <span className="jsIf">if</span> (
                  <span className="jsVarName">e</span>.
                  <span className="jsVarName">lengthComputable</span>) &#123;
                </div>
                <div className="i2">
                  <span className="jsVarName">percentageComplete</span> = (
                  <span className="jsVarName">e</span>.
                  <span className="jsVarName">loaded</span> /{" "}
                  <span className="jsVarName">e</span>.
                  <span className="jsVarName">total</span>) *{" "}
                  <span className="jsNumber">100</span>;
                </div>
                <div className="i1">&#125;</div>
                <div>&#125;);</div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsVarName">xhr</span>.
                  <span className="jsVarName">upload</span>.
                  <span className="jsMethod2">addEventListener</span>(
                  <span className="jsString">"load"</span>,{" "}
                  <span className="jsDeclaration">function</span> () &#123;
                </div>
                <div className="i1 jsComment">// Finished Uploading</div>
                <div>&#125;);</div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsVarName">xhr</span>.
                  <span className="jsMethod2">open</span>(
                  <span className="jsString">"PUT"</span>,{" "}
                  <span className="jsVarName">uploadURL</span>);
                </div>
                <div>
                  <span className="jsVarName">xhr</span>.
                  <span className="jsMethod2">overrideMimeType</span>(
                  <span className="jsVarName">contentType</span>);
                </div>
                <div>
                  <span className="jsVarName">xhr</span>.
                  <span className="jsMethod2">send</span>(
                  <span className="jsVarName">file</span>);
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Attachments_upload;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Attachments_upload.js